module.exports = {
    name: "Morecambe",

    base: {
        contact_address: "FREEPOST MORECAMBE GENERATION",
        contact_number: "0800 915 2493 (option 2)",
        contact_email: "hello@morecambeoffshorewind.com",
    },

    nav : {
        overview: {
            title: {
                en: "Overview",
                cym: "Trosolwg",
            },
            slug: {
                en: "",
                cym: "",
            },
        },
        theProject: {
            title: {
                en: "The Project",
                cym: "Y prosiect",
            },
            slug: {
                en: "the-project",
                cym: "y-prosiect",
            },

            projectWillLookLike: {
                title: {
                    en: "What the Project will look like",
                    cym: "Sut olwg fydd ar y Prosiect",
                },
                slug: {
                    en: "the-project",
                    cym: "y-prosiect",
                },
            },

            aboutProject: {
                title: {
                    en: "About the Project",
                    cym: "Ynglŷn â phrosiect",
                },
                slug: {
                    en: "about-project",
                    cym: "ynglyn-a-phrosiect",
                },
            },
            aboutUs: {
                title: {
                    en: "About us",
                    cym: "Amdanom ni",
                },
                slug: {
                    en: "about-us",
                    cym: "amdanom-ni",
                },
            },
            processes: {
                title: {
                    en: "Processes and Next Steps",
                    cym: "Prosesau a'r Camau Nesaf",
                },
                slug: {
                    en: "about-project",
                    cym: "ynglyn-a-phrosiect",
                },
            },



        },
        environmentalConsiderations: {
            title: {
                en: "Environmental Considerations",
                cym: "Ystyriaethau amgylcheddol",
            },
            slug: {
                en: "environmental-considerations",
                cym: "ystyriaethau-amgylcheddol",
            },
            ourWorkSoFar: {
                title: {
                    en: "Our work so far",
                    cym: "Ein gwaith hyd yn hyn",
                },
                slug: {
                    en: "our-work-so-far",
                    cym: "ein-gwaith-hyd-yn-hyn",
                },
            },
            commercialFisheries: {
                title: {
                    en: "Interactions with other marine users",
                    cym: "Rhyngweithio â defnyddwyr morol eraill",
                },
                slug: {
                    en: "commercial-fisheries-shipping-navigation",
                    cym: "pysgodfeydd-masnachol-llongau-mordwyo",
                },
            },
        },
        consultationHub: {
            title: {
                en: "Information Hub",
                cym: "Hyb Ymgynghori",
            },
            slug: {
                en: "consultationhub",
                cym: "consultationhub",
            },
        },
        influencingOurProject: {
            title: {
                en: "Contact us",
                cym: "Cysylltwch â ni",
            },
            slug: {
                en: "",
                cym: "",
            },
            meetTheTeam: {
                title: {
                    en: "Contact us",
                    cym: "Cwrdd â'r tîm",
                },
                slug: {
                    en: "meettheteams",
                    cym: "meettheteams",
                },
            },
            submittingFeedback: {
                title: {
                    en: "Submitting feedback",
                    cym: "Cyflwyno adborth",
                },
                slug: {
                    en: "have-your-say/feedback-form",
                    cym: "have-your-say/feedback-form",
                },
            },
            howToUse: {
                title: {
                    en: "How to use our consultation map",
                    cym: "Sut i ddefnyddio ein map ymgynghori",
                },
                slug: {
                    en: "have-your-say/using-consultation-map",
                    cym: "have-your-say/using-consultation-map",
                },
            },
            visualisations: {
                title: {
                    en: "Visualisations of the windfarm",
                    cym: "Delweddau o'r fferm wynt",
                },
                slug: {
                    en: "visualisations",
                    cym: "delweddau",
                },
            },
            consultationMap: {
                title: {
                    en: "Interactive map",
                    cym: "Delweddau o'r fferm wynt",
                },
                slug: {
                    en: "",
                    cym: "",
                },
            },
        }
    },

    locations: [
        // {
        //     title: {
        //         en: "Black Combe",
        //         cym: "Black Combe",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint1.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+1.pdf",
        //     lat: 54.257205,
        //     lng: -3.328957,
        // },
        // {
        //     title: {
        //         en: "Haverigg Point",
        //         cym: "Haverigg Point",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint2.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+2.pdf",
        //     lat: 54.189394,
        //     lng: -3.3080824,
        // },
        // {
        //     title: {
        //         en: "Ulverston (Hoad Monument)",
        //         cym: "Ulverston (Hoad Monument)",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint3.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+3.pdf",
        //     lat: 54.202486,
        //     lng: -3.0829197,
        // },
        {
            title: {
                en: "High Haume Farm (Dalton-in-Furness)",
                cym: "High Haume Farm (Dalton-in-Furness)",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint4.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+4.pdf",
            lat: 54.170456,
            lng: -3.1902332,
        },
        {
            title: {
                en: "Walney Island (Biggar Bank Road)",
                cym: "Walney Island (Biggar Bank Road)",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint5.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+5.pdf",
            lat: 54.097029,
            lng: -3.2576921,
        },
        {
            title: {
                en: "South Walney Nature Reserve",
                cym: "South Walney Nature Reserve",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint6.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+6.pdf",
            lat: 54.049009,
            lng: -3.328957,
        },
        {
            title: {
                en: "Heysham Head, Chapel Hill The-Barrows",
                cym: "Heysham Head, Chapel Hill The-Barrows",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint7.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+7.pdf",
            lat: 54.04667,
            lng: -2.9034988,
        },
        {
            title: {
                en: "Fleetwood (Rossall Point)",
                cym: "Fleetwood (Rossall Point)",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint8.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+8.pdf",
            lat: 53.922946,
            lng: -3.0446808,
        },
        {
            title: {
                en: "Blackpool (near Tower)",
                cym: "Blackpool (near Tower)",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint9.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+9.pdf",
            lat: 53.81272,
            lng: -3.0562136,
        },
        {
            title: {
                en: "Lytham St Anne’s",
                cym: "Lytham St Anne’s",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint10.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+10.pdf",
            lat: 53.747115,
            lng: -3.0333978,
        },
        {
            title: {
                en: "Southport Pier",
                cym: "Southport Pier",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint11.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+11.pdf",
            lat: 53.654064,
            lng: -3.0135533,
        },
        {
            title: {
                en: "Formby Point",
                cym: "Formby Point",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint12.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+12.pdf",
            lat: 53.551887,
            lng: -3.1032449,
        },
        {
            title: {
                en: "Clieves Hill",
                cym: "Clieves Hill",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint13.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+13.pdf",
            lat: 53.558829,
            lng: -2.9306285,
        },
        {
            title: {
                en: "Crosby Beach",
                cym: "Crosby Beach",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint14.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+14.pdf",
            lat: 53.481827,
            lng: -3.0464224,
        },
        {
            title: {
                en: "Fort Perch Rock, New Brighton",
                cym: "Fort Perch Rock, New Brighton",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint15.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+15.pdf",
            lat: 53.441988,
            lng: -3.0413178,
        },
        // {
        //     title: {
        //         en: "Hoylake, Hilbre Point",
        //         cym: "Hoylake, Hilbre Point",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint16.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+16.pdf",
        //     lat: 53.386997,
        //     lng: -3.1998677,
        // },
        {
            title: {
                en: "Talacre Beach (Point of Ayr)",
                cym: "Talacre Beach (Point of Ayr)",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint17.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+17.pdf",
            lat: 53.354037,
            lng: -3.3228045,
        },
        // {
        //     title: {
        //         en: "Prestatyn (Nova Centre)",
        //         cym: "Prestatyn (Nova Centre)",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint18.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+18.pdf",
        //     lat: 53.354037,
        //     lng: -3.3228045,
        // },
        // {
        //     title: {
        //         en: "Bryn-Ilwyn Viewpoint (Prestatyn)",
        //         cym: "Bryn-Ilwyn Viewpoint (Prestatyn)",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint19.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+19.pdf",
        //     lat: 53.32542,
        //     lng: -3.3910917,
        // },
        // {
        //     title: {
        //         en: "Graig Fawr, Clwydian Range",
        //         cym: "Graig Fawr, Clwydian Range",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint20.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+20.pdf",
        //     lat: 53.312099,
        //     lng: -3.4131586,
        // },
        // {
        //     title: {
        //         en: "Rhos Point",
        //         cym: "Rhos Point",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint21.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+21.pdf",
        //     lat: 53.314692,
        //     lng: -3.7411979,
        // },
        // {
        //     title: {
        //         en: "Llandudno Promenade",
        //         cym: "Llandudno Promenade",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint22.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+22.pdf",
        //     lat: 53.32231,
        //     lng: -3.8162803,
        // },
        {
            title: {
                en: "Great Orme’s Head",
                cym: "Great Orme’s Head",
            },

            pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/viewpoints/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint23.pdf",
            pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+23.pdf",
            lat: 53.33308,
            lng: -3.8536682,
        },
        // {
        //     title: {
        //         en: "Silecroft Beach",
        //         cym: "Silecroft Beach",
        //     },

        //     pdfA: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2a+Visuals+-+Viewpoint24.pdf",
        //     pdfB: "https://bp-mmt.s3.eu-west-2.amazonaws.com/Chapter+18+SLVIA+Figures+2b+Visuals+-+Viewpoint+24.pdf",
        //     lat: 54.218136,
        //     lng: -3.3497714,
        // },
    ],

    visualisations: {
        pdfA: {
            en: "Visual A",
            cym: "Gweledol A",
        },

        pdfB: {
            en: "Visual B",
            cym: "Gweledol B",
        },

        visualAText: {
            en: "Visual A – shows the maximum height of our turbines (up to 345m)",
            cym: "Gweledol A – yn dangos uchder uchaf ein tyrbinau (hyd at 345m)"
        },

        visualBText: {
            en: "Visual B – shows the maximum number of turbines (up to 40)",
            cym: "Gweledol B – yn dangos uchafswm nifer y tyrbinau (hyd at 40)"
        }
    },

    consultation: {
        mapId: 1,
        mapSlug: "/morecambe/map",
         // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
        mapUrl: "https://feedback.morecambeandmorgan.com",
        feedback_active: true,
        closed_message:
            "This consultation is closed and is no longer accepting feedback.",

        // Consultation close countdown. If set to true, show countdown in site header
        has_countdown: false,

        hasMap: true,

        themes: [
            {
                name: {
                    en: "General",
                    cym: "Cyffredinol",
                },
                url: "section-1",
                feedback_url: "",
                icon: "uncategorised",
                question: {
                    en: "Do you have any comments on the work we’ve undertaken on the Project to date generally, as well as specifically on the areas listed (1.1 to 1.16).",
                    cym: "A oes gennych unrhyw sylwadau ar y gwaith rydym wedi’i wneud ar y prosiect hyd yn hyn yn gyffredinol, yn ogystal ag yn benodol ar y meysydd a restrir (1.1 i 1.16).",
                },

                topics: [
                    {
                        "key": "01-morecambe-question-01-topic",
                        "question": {
                            en: "Marine geology, oceanography and physical processes",
                            cym: "Daeareg forol, eigioneg a phrosesau ffisegol"
                        }
                    },

                    {
                        "key": "01-morecambe-question-02-topic",
                        "question": {
                            en: "Marine sediment and water quality",
                            cym: "Gwaddod morol ac ansawdd dŵr"
                        }
                    },

                    {
                        "key": "01-morecambe-question-03-topic",
                        "question": {
                            en: "Benthic ecology",
                            cym: "Ecoleg benthig"
                        }
                    },

                    {
                        "key": "01-morecambe-question-04-topic",
                        "question": {
                            en: "Fish and shellfish ecology",
                            cym: "Ecoleg pysgod a physgod cregyn"
                        }
                    },

                    {
                        "key": "01-morecambe-question-05-topic",
                        "question": {
                            en: "Marine mammals",
                            cym: "Mamaliaid morol"
                        }
                    },

                    {
                        "key": "01-morecambe-question-06-topic",
                        "question": {
                            en: "Offshore ornithology",
                            cym: "Adareg ar y môr"
                        }
                    },

                    {
                        "key": "01-morecambe-question-07-topic",
                        "question": {
                            en: "Commercial fisheries",
                            cym: "Pysgodfeydd masnachol"
                        }
                    },

                    {
                        "key": "01-morecambe-question-08-topic",
                        "question": {
                            en: "Shipping and navigation",
                            cym: "Llongau a mordwyo"
                        }
                    },

                    {
                        "key": "01-morecambe-question-09-topic",
                        "question": {
                            en: "Offshore archaeology and cultural heritage",
                            cym: "Archaeoleg alltraeth a threftadaeth ddiwylliannol"
                        }
                    },

                    {
                        "key": "01-morecambe-question-10-topic",
                        "question": {
                            en: "Civil and military aviation and radar",
                            cym: "Hedfan sifil a milwrol a radar"
                        }
                    },

                    {
                        "key": "01-morecambe-question-11-topic",
                        "question": {
                            en: "Infrastructure and other users",
                            cym: "Isadeiledd a defnyddwyr eraill"
                        }
                    },

                    {
                        "key": "01-morecambe-question-12-topic",
                        "question": {
                            en: "Seascape, Landscape and Visual Impact Assessment",
                            cym: "Asesiad Morlun, Tirwedd ac Effaith Weledol"
                        }
                    },

                    {
                        "key": "01-morecambe-question-13-topic",
                        "question": {
                            en: "Human health",
                            cym: "Iechyd dynol"
                        }
                    },

                    {
                        "key": "01-morecambe-question-14-topic",
                        "question": {
                            en: "Socioeconomics, tourism and recreation",
                            cym: "Economeg gymdeithasol, twristiaeth a hamdden"
                        }
                    },

                    {
                        "key": "01-morecambe-question-15-topic",
                        "question": {
                            en: "Climate change",
                            cym: "Newid hinsawdd"
                        }
                    },

                    {
                        "key": "01-morecambe-question-16-topic",
                        "question": {
                            en: "Traffic and transport",
                            cym: "Traffig a thrafnidiaeth"
                        }
                    },
                ],
                key: "01-morecambe-section",
            },
            {
                name: {
                    en: "Environmental",
                    cym: "Amgylcheddol",
                },
                url: "section-2",
                feedback_url: "page-2/",
                icon: "environment",
                question: {
                    en: "Do you have any comments on our work to understand the technical and environmental constraints of the areas offered to us by the Crown Estate as part of its Round 4 leasing process?",
                    cym: "A oes gennych unrhyw sylwadau am ein gwaith i ddeall cyfyngiadau technegol ac amgylcheddol yr ardaloedd a gynigir i ni gan Ystad y Goron fel rhan o'i phroses brydlesu Rownd 4?",
                },
                key: "02-morecambe-section",
            },
            {
                name: {
                    en: "Community",
                    cym: "Cymuned",
                },
                url: "section-3",
                feedback_url: "page-3/",
                icon: "community",
                question: {
                    en: "Do you have any comments on the possible community benefits of Morecambe Offshore Windfarm, and how the project can support the local, regional and national economy?",
                    cym: "A oes gennych unrhyw sylwadau ar fanteision cymunedol posibl Fferm Wynt Alltraeth Morecambe, a sut y gall y prosiect gefnogi’r economi leol, ranbarthol a chenedlaethol?",
                },
                key: "03-morecambe-section",
            },
            {
                name: {
                    en: "Construction",
                    cym: "Adeiladu",
                },
                url: "section-4",
                feedback_url: "page-4/",
                icon: "construction",
                question: {
                    en: "Do you have any comments on how we are proposing to construct Morecambe Offshore Windfarm?",
                    cym: "A oes gennych unrhyw sylwadau ar sut yr ydym yn bwriadu adeiladu Fferm Wynt Alltraeth Morecambe?",
                },
                key: "04-morecambe-section",
            },
            {
                name: {
                    en: "Commercial",
                    cym: "Masnachol",
                },
                url: "section-5",
                feedback_url: "page-5/",
                icon: "commercial",
                question: {
                    en: "Do you have any comments on how our Project interacts with commercial fisheries, shipping and navigation?",
                    cym: "A oes gennych unrhyw sylwadau ar sut mae ein prosiect yn rhyngweithio â physgodfeydd masnachol, llongau a mordwyo?",
                },
                key: "05-morecambe-section",
            },
            {
                name: {
                    en: "General",
                    cym: "Cyffredinol",
                },
                url: "section-6",
                feedback_url: "page-6/",
                icon: "uncategorised",
                question: {
                    en: "Do you have any comments on anything else within this current consultation?",
                    cym: "A oes gennych unrhyw sylwadau ar unrhyw beth arall o fewn yr ymgynghoriad presennol hwn?",
                },
                key: "06-morecambe-section",
            },
        ],
    },

	statConsultationMaterials: {
		chapter1: {
			index: 1,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 1",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 1",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 1 Introduction",
                        cym: "Chapter 1 Introduction"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-01+Chapter+1+Introduction.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-01+Chapter+1+Introduction.pdf"
                    }
                },

                {
                  title: {
                      en: "Chapter 1 Introduction Figures",
                      cym: "Chapter 1 Introduction Figures"
                  },

                  url: {
                      en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+1+Introduction+Figures.pdf",
                      cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+1+Introduction+Figures.pdf"
                  }
                },
			]
		},
		chapter2: {
			index: 2,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 2",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 2",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 2 Need for the Project",
                        cym: "Chapter 2 Need for the Project"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-02+Chapter+2+Need+for+the+Project.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-02+Chapter+2+Need+for+the+Project.pdf"
                    }
                },
			]
		},
		chapter3: {
			index: 3,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 3",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 3",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 3 Policy and Legislation",
                        cym: "Chapter 3 Policy and Legislation"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-03+Chapter+3+Policy+and+Legislation.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-03+Chapter+3+Policy+and+Legislation.pdf"
                    }
                },
			]
		},
		chapter4: {
			index: 4,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 4",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 4",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 4 Site Selection and Assessment of Alternatives",
                        cym: "Chapter 4 Site Selection and Assessment of Alternatives"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-04+Chapter+4+Site+Selection+%26+Assessment+of+Alternatives.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-04+Chapter+4+Site+Selection+%26+Assessment+of+Alternatives.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 4 Site Selection and Assessment of Alternatives Figures",
                        cym: "Chapter 4 Site Selection and Assessment of Alternatives Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+4+Site+Selection+%26+AoA+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+4+Site+Selection+%26+AoA+Figures.pdf"
                    }
                },

			]
		},
		chapter5: {
			index: 5,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 5",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 5",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 5 Project Description",
                        cym: "Chapter 5 Project Description"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-05+Chapter+5+Project+Description.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-05+Chapter+5+Project+Description.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 5 Project Description Figures",
                        cym: "Chapter 5 Project Description Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+5+Project+Description+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+5+Project+Description+Figures.pdf"
                    }
                },

			]
		},
		chapter6: {
			index: 6,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 6",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 6",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 6 EIA Methodology",
                        cym: "Chapter 6 EIA Methodology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-06+Chapter+6+EIA+Methodology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-06+Chapter+6+EIA+Methodology.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 6.1 CEA Long List",
                        cym: "Appendix 6.1 CEA Long List"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-6.1+Appendix+6.1+CEA+Long+List.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-6.1+Appendix+6.1+CEA+Long+List.pdf"
                    }
                },
			]
		},
		chapter7: {
			index: 7,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 7",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 7",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 7 Marine Geology, Oceanography and Physical Processes",
                        cym: "Chapter 7 Marine Geology, Oceanography and Physical Processes"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-07+Chapter+7+Marine+Geology%2C+Oceanography+and+Physical+Processes.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-07+Chapter+7+Marine+Geology%2C+Oceanography+and+Physical+Processes.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 7.1 Offshore Geophysical Survey Report",
                        cym: "Appendix 7.1 Offshore Geophysical Survey Report"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-7.1+Appendix+7.1+Offshore+Geophysical+Survey+Report.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-7.1+Appendix+7.1+Offshore+Geophysical+Survey+Report.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 7 Marine Geology, Oceanography and Physical Processes Figures",
                        cym: "Chapter 7 Marine Geology, Oceanography and Physical Processes Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+7+MGOPP+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+7+MGOPP+Figures.pdf"
                    }
                },
			]
		},
		chapter8: {
			index: 8,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 8",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 8",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 8 Marine Sediment and Water Quality",
                        cym: "Chapter 8 Marine Sediment and Water Quality"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-08+Chapter+8+Marine+Sediment+and+Water+Quality.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-08+Chapter+8+Marine+Sediment+and+Water+Quality.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 8 Marine Sediment and Water Quality Figures",
                        cym: "Chapter 8 Marine Sediment and Water Quality Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+8+Marine+Sediment+and+Water+Quality+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+8+Marine+Sediment+and+Water+Quality+Figures.pdf"
                    }
                },
			]
		},
		chapter9: {
			index: 9,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 9",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 9",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 9 Benthic Ecology",
                        cym: "Chapter 9 Benthic Ecology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-09+Chapter+9+Benthic+Ecology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-09+Chapter+9+Benthic+Ecology.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 9.1 Benthic Characterisation Survey Technical Report",
                        cym: "Appendix 9.1 Benthic Characterisation Survey Technical Report"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-9.1+Appendix+9.1+Benthic+Characterisation+Survey+Technical+Report.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-9.1+Appendix+9.1+Benthic+Characterisation+Survey+Technical+Report.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 9.2 Benthic Ecology Sensitivity Marine Evidence-based Sensitivity Assessment",
                        cym: "Appendix 9.2 Benthic Ecology Sensitivity Marine Evidence-based Sensitivity Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-9.2+Appendix+9.2+Benthic+Ecology+Sensitivity+Marine+Evidence-based+Sensitivity+Assessment+(MarESA).pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-9.2+Appendix+9.2+Benthic+Ecology+Sensitivity+Marine+Evidence-based+Sensitivity+Assessment+(MarESA).pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 9 Benthic Ecology Figures",
                        cym: "Chapter 9 Benthic Ecology Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+9+Benthic+Ecology+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+9+Benthic+Ecology+Figures.pdf"
                    }
                },
			]
		},
		chapter10: {
			index: 10,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 10",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 10",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 10 Fish and Shellfish Ecology",
                        cym: "Chapter 10 Fish and Shellfish Ecology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-10+Chapter+10+Fish+and+Shellfish+Ecology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-10+Chapter+10+Fish+and+Shellfish+Ecology.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 10 Fish and Shellfish Ecology Figures",
                        cym: "Chapter 10 Fish and Shellfish Ecology Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+10+Fish+and+Shellfish+Ecology+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+10+Fish+and+Shellfish+Ecology+Figures.pdf"
                    }
                },
			]
		},
		chapter11: {
			index: 11,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 11",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 11",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 11 Marine Mammals",
                        cym: "Chapter 11 Marine Mammals"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-11+Chapter+11+Marine+Mammals.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-11+Chapter+11+Marine+Mammals.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 11.1 Underwater Noise Assessment",
                        cym: "Appendix 11.1 Underwater Noise Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.1+Appendix+11.1+Underwater+Noise+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.1+Appendix+11.1+Underwater+Noise+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 11.2 MM Information and Survey Data",
                        cym: "Appendix 11.2 MM Information and Survey Data"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.2+Appendix+11.2+MM+Information+and+Survey+Data.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.2+Appendix+11.2+MM+Information+and+Survey+Data.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 11.3 Marine Mammals UXO Assessment",
                        cym: "Appendix 11.3 Marine Mammals UXO Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.3+Appendix+11.3+Marine+Mammals+UXO+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.3+Appendix+11.3+Marine+Mammals+UXO+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 11.4 Marine Mammals CEA Screening",
                        cym: "Appendix 11.4 Marine Mammals CEA Screening"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.4+Appendix+11.4+Marine+Mammals+CEA+Screening.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-11.4+Appendix+11.4+Marine+Mammals+CEA+Screening.pdf"
                    }
                },

                {
                    title: {
                        en: "Chapter 11 Marine Mammals Figures",
                        cym: "Chapter 11 Marine Mammals Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+11+Marine+Mammals+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+11+Marine+Mammals+Figures.pdf"
                    }
                },
			]
		},
		chapter12: {
			index: 12,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 12",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 12",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 12 Offshore Ornithology",
                        cym: "Chapter 12 Offshore Ornithology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-12+Chapter+12+Offshore+Ornithology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-12+Chapter+12+Offshore+Ornithology.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 12.1 Offshore Ornithology Technical Report",
                        cym: "Appendix 12.1 Offshore Ornithology Technical Report"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-12.1+Appendix+12.1+Offshore+Ornithology+Technical+Report+.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-12.1+Appendix+12.1+Offshore+Ornithology+Technical+Report+.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 12.2 Aerial Surveys Annual Report March 2021 to February 2022",
                        cym: "Appendix 12.2 Aerial Surveys Annual Report March 2021 to February 2022"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-12.2+Appendix+12.2+Aerial+Surveys+Annual+Report+March+2021+to+February+2022.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-12.2+Appendix+12.2+Aerial+Surveys+Annual+Report+March+2021+to+February+2022.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 12 Offshore Ornithology Figures",
                        cym: "Chapter 12 Offshore Ornithology Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+12+Offshore+Ornithology+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+12+Offshore+Ornithology+Figures.pdf"
                    }
                },

			]
		},
		chapter13: {
			index: 13,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 13",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 13",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 13 Commercial Fisheries",
                        cym: "Chapter 13 Commercial Fisheries"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-13+Chapter+13+Commercial+Fisheries.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-13+Chapter+13+Commercial+Fisheries.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 13.1 Technical Report",
                        cym: "Appendix 13.1 Technical Report"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-13.1+Appendix+13.1+Technical+Report.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-13.1+Appendix+13.1+Technical+Report.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 13 Commercial Fisheries Figures",
                        cym: "Chapter 13 Commercial Fisheries Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+13+Commercial+Fisheries+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+13+Commercial+Fisheries+Figures.pdf"
                    }
                },
			]
		},
		chapter14: {
			index: 14,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 14",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 14",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 14 Shipping and Navigation",
                        cym: "Chapter 14 Shipping and Navigation"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-14+Chapter+14+Shipping+and+Navigation.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-14+Chapter+14+Shipping+and+Navigation.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 14.1 Navigational Risk Assessment",
                        cym: "Appendix 14.1 Navigational Risk Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-14.1+Appendix+14.1+Navigational+Risk+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-14.1+Appendix+14.1+Navigational+Risk+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 14.2 Cumulative Regional Navigation Risk Assessment",
                        cym: "Appendix 14.2 Cumulative Regional Navigation Risk Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-14.2+Appendix+14.2+Cumulative+Regional+Navigation+Risk+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-14.2+Appendix+14.2+Cumulative+Regional+Navigation+Risk+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 14 Shipping and Navigation Figures",
                        cym: "Chapter 14 Shipping and Navigation Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+14+Shipping+and+Navigation+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+14+Shipping+and+Navigation+Figures.pdf"
                    }
                },
			]
		},
		chapter15: {
			index: 15,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 15",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 15",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 15 Marine Archaeology and Cultural Heritage",
                        cym: "Chapter 15 Marine Archaeology and Cultural Heritage"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-15+Chapter+15+Marine+Archaeology+and+Cultural+Heritage.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-15+Chapter+15+Marine+Archaeology+and+Cultural+Heritage.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 15.1 Archaeological Assessment of Geophysical and Hydrographic Data",
                        cym: "Appendix 15.1 Archaeological Assessment of Geophysical and Hydrographic Data"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-15.1+Appendix+15.1+Archaeological+Assessment+of+Geophysical+and+Hydrographic+Data.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-15.1+Appendix+15.1+Archaeological+Assessment+of+Geophysical+and+Hydrographic+Data.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 15.2 Setting Assessment Screening",
                        cym: "Appendix 15.2 Setting Assessment Screening"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-15.2+Appendix+15.2+Setting+Assessment+Screening.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-15.2+Appendix+15.2+Setting+Assessment+Screening.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 15 Marine Archaeology and Cultural Heritage Figures",
                        cym: "Chapter 15 Marine Archaeology and Cultural Heritage Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+15+Marine+Archaeology+and+Cultural+Heritage+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+15+Marine+Archaeology+and+Cultural+Heritage+Figures.pdf"
                    }
                },
			]
		},
		chapter16: {
			index: 16,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 16",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 16",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 16 Civil and Military Aviation and Radar",
                        cym: "Chapter 16 Civil and Military Aviation and Radar"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-16+Chapter+16+Civil+and+Military+Aviation+and+Radar.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-16+Chapter+16+Civil+and+Military+Aviation+and+Radar.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 16.1 Airspace Analysis and Radar Modelling",
                        cym: "Appendix 16.1 Airspace Analysis and Radar Modelling"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-16.1+Appendix+16.1+Airspace+Analysis+and+Radar+Modelling.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-16.1+Appendix+16.1+Airspace+Analysis+and+Radar+Modelling.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 16 Civil and Military Radar Figures",
                        cym: "Chapter 16 Civil and Military Radar Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+16+Civil+and+Military+Aviation+and+Radar+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+16+Civil+and+Military+Aviation+and+Radar+Figures.pdf"
                    }
                },
			]
		},
		chapter17: {
			index: 17,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 17",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 17",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 17 Infrastructure and Other Users",
                        cym: "Chapter 17 Infrastructure and Other Users"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-17+Chapter+17+Infrastructure+and+Other+Users.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-17+Chapter+17+Infrastructure+and+Other+Users.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 17 Infrastructure and Other Users Figures",
                        cym: "Chapter 17 Infrastructure and Other Users Figures"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+17+Infrastructure+and+Other+Users+Figures.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+17+Infrastructure+and+Other+Users+Figures.pdf"
                    }
                },
			]
		},
		chapter18: {
			index: 18,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 18",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 18",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 18 SLVIA",
                        cym: "Chapter 18 SLVIA"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-18+Chapter+18+SLVIA.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-18+Chapter+18+SLVIA.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 18.1 SLVIA Methodology",
                        cym: "Appendix 18.1 SLVIA Methodology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-18.1+Appendix+18.1+SLVIA+Methodology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-18.1+Appendix+18.1+SLVIA+Methodology.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 18.2 SLVIA Preliminary Assessment",
                        cym: "Appendix 18.2 SLVIA Preliminary Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-18.2+Appendix+18.2+SLVIA+Preliminary+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-18.2+Appendix+18.2+SLVIA+Preliminary+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 18.3 SLVIA Viewpoint Assessment",
                        cym: "Appendix 18.3 SLVIA Viewpoint Assessment"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-18.3+Appendix+18.3+SLVIA+Viewpoint+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-18.3+Appendix+18.3+SLVIA+Viewpoint+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 18 SLVIA Figures 1",
                        cym: "Chapter 18 SLVIA Figures 1"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+18+SLVIA+Figures+1.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+18+SLVIA+Figures+1.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 18 SLVIA Figures Visuals 2a",
                        cym: "Chapter 18 SLVIA Figures Visuals 2a"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+18+SLVIA+Figures+Visuals+2a.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+18+SLVIA+Figures+Visuals+2a.pdf"
                    }
                },
                {
                    title: {
                        en: "Chapter 18 SLVIA Figures Visuals 2b",
                        cym: "Chapter 18 SLVIA Figures Visuals 2b"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+18+SLVIA+Figures+Visuals+2b.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Figures/Chapter+18+SLVIA+Figures+Visuals+2b.pdf"
                    }
                },
			]
		},
		chapter19: {
			index: 19,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 19",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 19",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 19 Human Health",
                        cym: "Chapter 19 Human Health"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-19+Chapter+19+Human+Health.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-19+Chapter+19+Human+Health.pdf"
                    }
                },
			]
		},
		chapter20: {
			index: 20,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 20",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 20",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 20 Socio-economics, Tourism and Recreation",
                        cym: "Chapter 20 Socio-economics, Tourism and Recreation"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-20+Chapter+20+Socio-economics%2C+Tourism+and+Recreation.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-20+Chapter+20+Socio-economics%2C+Tourism+and+Recreation.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 20.1 Economic Impact of Offshore Wind - Methodology",
                        cym: "Appendix 20.1 Economic Impact of Offshore Wind - Methodology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-20.1+Appendix+20.1+Offshore+Wind%2C+Economic+Impact+Methodology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-20.1+Appendix+20.1+Offshore+Wind%2C+Economic+Impact+Methodology.pdf"
                    }
                },
			]
		},

		chapter21: {
			index: 21,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 21",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 21",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 21 Climate Change",
                        cym: "Chapter 21 Climate Change"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-21+Chapter+21+Climate+Change.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-21+Chapter+21+Climate+Change.pdf"
                    }
                },
                {
                    title: {
                        en: "Appendix 21.1 GHG Methodology",
                        cym: "Appendix 21.1 GHG Methodology"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-21.1+Appendix+21.1+GHG+Methodology.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Appendices/FLO-MOR-REP-0006-21.1+Appendix+21.1+GHG+Methodology.pdf"
                    }
                },
			]
		},
		chapter22: {
			index: 22,

			title: {
				en: "Preliminary Environmental Information Report (PEIR) Chapter 22",
				cym: "Preliminary Environmental Information Report (PEIR) Chapter 22",
			},

			downloads: [
                {
                    title: {
                        en: "Chapter 22 Traffic and Transport",
                        cym: "Chapter 22 Traffic and Transport"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-22+Chapter+22+Traffic+and+Transport.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Chapters/FLO-MOR-REP-0006-22+Chapter+22+Traffic+and+Transport.pdf"
                    }
                },
			]
		},

        nts: {
			index: 23,

			title: {
				en: "Non-Technical Summary",
				cym: "Non-Technical Summary",
			},

			downloads: [
                {
                    title: {
                        en: "Non-Technical Summary",
                        cym: "Non-Technical Summary"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0006+Non-Technical+Summary.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Morecambe+Non-Technical+Summary+(Welsh).pdf"
                    }
                },
			]
		},

        reports: {
			index: 24,

			title: {
				en: "Reports",
				cym: "Reports",
			},

			downloads: [
                {
                    title: {
                        en: "Draft RIAA - Report to Inform the Appropriate Assessment",
                        cym: "Draft RIAA - Report to Inform the Appropriate Assessment"
                    },

                    date: {
                        en: "(Made available 24/04/23)",
                        cym: "(Ar gael o 24/04/23)"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0005+Draft+Report+to+Inform+Appropriate+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0005+Draft+Report+to+Inform+Appropriate+Assessment.pdf"
                    }
                },
                {
                    title: {
                        en: "Draft RIAA - Appendix 1 Habitat Regulations Assessment Screening Report",
                        cym: "Draft RIAA - Appendix 1 Habitat Regulations Assessment Screening Report"
                    },

                    date: {
                        en: "(Made available 24/04/23)",
                        cym: "(Ar gael o 24/04/23)"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0004_Morecambe_Offshore_Windfarm_RIAA+Appendix+I_HRA_Screening.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0004_Morecambe_Offshore_Windfarm_RIAA+Appendix+I_HRA_Screening.pdf"
                    }
                },
                {
                    title: {
                        en: "Draft Information for Marine Conservation Zone Assessment",
                        cym: "Draft Information for Marine Conservation Zone Assessment"
                    },

                    date: {
                        en: "(Made available 24/04/23)",
                        cym: "(Ar gael o 24/04/23)"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0051+Draft+Information+for+MCZ+Assessment.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0051+Draft+Information+for+MCZ+Assessment.pdf"
                    }
                }
			]
		},

		consultationMaterials: {
			index: 25,

			title: {
				en: "Consultation materials",
				cym: "Deunyddiau ymgynghori",
			},

			downloads: [
                {
                    title: {
                        en: "Consultation Brochure (Single pages)",
                        cym: "Consultation Brochure (Single pages)"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-V15_pages.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-Welsh-V16_pages.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/stat-brochure.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/stat-brochure.jpg"
                    }
                },
                {
                    title: {
                        en: "Consultation Brochure (Spread pages)",
                        cym: "Consultation Brochure (Spread pages)"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-V15_spreads.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-Welsh-V16_spreads.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/stat-brochure.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/stat-brochure.jpg"
                    }
                },
                {
                    title: {
                        en: "Feedback Form",
                        cym: "Ffurflen Adborth"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/MORECAMBE-Feedback Form-V11.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/MORECAMBE-Feedback-Form_Welsh-V1.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/feedback-form.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/feedback-form.jpg"
                    }
                },
                {
                    type: "video",
                    videoId: "827547013",

                    title: {
                        en: "Morecambe Offshore Windfarm Generation Assets - Online event, 16 May 2023",
                        cym: "Morecambe Offshore Windfarm Generation Assets - Online event, 16 May 2023",
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/stat-video-webinar.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/stat-video-webinar.jpg"
                    }
                },
                {
                    title: {
                        en: "Statement of Community Consultation (SoCC)",
                        cym: "Datganiad o Ymgynghori Cymunedol"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Consultation/12377+-+MORECAMBE-SOCC-V17_pages.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Consultation/12377+-+MORECAMBE-SOCC-PRINT-V15-Welsh.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/socc.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/socc.jpg"
                    }
                },
                {
                    title: {
                        en: "Section 42 Notice",
                        cym: "Hysbysiad Adran 42"
                    },

                    date: {
                        en: "(Made available 03/05/23)",
                        cym: "(Ar gael o 03/05/23)"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Morecambe+S42+email_letter.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Section+42+launch+comms+(Welsh).pdf"
                    }
                },
                {
                    title: {
                        en: "Section 47 Notice (a notice publicising the SoCC)",
                        cym: "Hysbysiad Adran 47 (hysbysiad yn rhoi cyhoeddusrwydd i’r Datganiad o Ymgynghori Cymunedol)"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/Morecambe-Offshore-Windfarm-Section-47-notice(English).pdf",
                        cym: "/assets/images/shared/downloads/morecambe/Morecambe-Offshore-Windfarm-Section-47-notice(Welsh).pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/section-47.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/section-47.jpg"
                    }
                },
                {
                    title: {
                        en: "Section 48 Notice (duty to publicise)",
                        cym: "Hysbysiad Adran 48"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/Morecambe-Section-48-notice.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/Morecambe-Section-48-notice(Welsh).pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/section-48.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/section-48.jpg"
                    }
                },
                {
                    title: {
                        en: "Deposit Locations",
                        cym: "Deposit Locations"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/morecambe-deposit-locations.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/Morecambe-deposit-locations-Welsh.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/deposit-locations.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/deposit-locations.jpg"
                    }
                },
                {
                    title: {
                        en: "Consultation Poster",
                        cym: "Consultation Poster"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/MMMT-Poster.pdf",
                        cym: "/assets/images/shared/downloads/MM-Poster.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/poster.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/poster.jpg"
                    }
                },
			]
		},

		consultationMaterialswelsh: {
			index: 26,

			title: {
				en: "Deunyddiau ymgynghori",
				cym: "Deunyddiau ymgynghori",
			},

			downloads: [
                {
                    title: {
                        en: "Y newyddion diweddaraf am y Prosiect: Hydref 2023",
                        cy: "Y newyddion diweddaraf am y Prosiect: Hydref 2023",
                    },

                    url: {
                        en: "/assets/images/downloads/MORECAMBE_GEN_Newsletter_WELSH.pdf",
                        cym: "/assets/images/downloads/MORECAMBE_GEN_Newsletter_WELSH.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/MORECAMBE_GEN_Newsletter_WELSH-1.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/MORECAMBE_GEN_Newsletter_WELSH-1.jpg"
                    }
                },
                {
                    title: {
                        en: "Non-Technical Summary",
                        cy: "Non-Technical Summary",
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Morecambe+Non-Technical+Summary+(Welsh).pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Morecambe+Non-Technical+Summary+(Welsh).pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/nts.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/nts.jpg"
                    }
                },
                {
                    title: {
                        en: "Consultation Brochure (Single pages)",
                        cy: "Consultation Brochure (Single pages)",
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-Welsh-V16_pages.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-Welsh-V16_pages.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/stat-brochure-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/stat-brochure-welsh.jpg"
                    }
                },
                {
                    title: {
                        en: "Consultation Brochure (Spread pages)",
                        cym: "Consultation Brochure (Spread pages)"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-Welsh-V16_spreads.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/MORECAMBE-Brochure-Welsh-V16_spreads.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/stat-brochure-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/stat-brochure-welsh.jpg"
                    }
                },
                {
                    title: {
                        en: "Ffurflen Adborth",
                        cym: "Ffurflen Adborth"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/MORECAMBE-Feedback-Form_Welsh-V1.pdf",
                        cym: "/assets/images/shared/downloads/morecambe/MORECAMBE-Feedback-Form_Welsh-V1.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/feedback-form-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/feedback-form-welsh.jpg"
                    }
                },
                {
                    title: {
                        en: "Datganiad o Ymgynghori Cymunedol (SoCC)",
                        cym: "Datganiad o Ymgynghori Cymunedol"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Consultation/12377+-+MORECAMBE-SOCC-PRINT-V15-Welsh.pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Consultation/12377+-+MORECAMBE-SOCC-PRINT-V15-Welsh.pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/socc-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/socc-welsh.jpg"
                    }
                },
                {
                    title: {
                        en: "Hysbysiad Adran 42",
                        cym: "Hysbysiad Adran 42"
                    },

                    date: {
                        en: "(Ar gael o 03/05/23)",
                        cym: "(Ar gael o 03/05/23)"
                    },

                    url: {
                        en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Section+42+launch+comms+(Welsh).pdf",
                        cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/Section+42+launch+comms+(Welsh).pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/section-42-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/section-42-welsh.jpg"
                    }
                },
                {
                    title: {
                        en: "Hysbysiad Adran 47 (hysbysiad yn rhoi cyhoeddusrwydd i’r Datganiad o Ymgynghori Cymunedol)",
                        cym: "Hysbysiad Adran 47 (hysbysiad yn rhoi cyhoeddusrwydd i’r Datganiad o Ymgynghori Cymunedol)"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/Morecambe-Offshore-Windfarm-Section-47-notice(Welsh).pdf",
                        cym: "/assets/images/shared/downloads/morecambe/Morecambe-Offshore-Windfarm-Section-47-notice(Welsh).pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/section-47-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/section-47-welsh.jpg"
                    }
                },
                {
                    title: {
                        en: "Hysbysiad Adran 48",
                        cym: "Hysbysiad Adran 48"
                    },

                    url: {
                        en: "/assets/images/shared/downloads/morecambe/Morecambe-Section-48-notice(Welsh).pdf",
                        cym: "/assets/images/shared/downloads/morecambe/Morecambe-Section-48-notice(Welsh).pdf"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/section-48-welsh.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/section-48-welsh.jpg"
                    }
                },
			]
		},



		visualisations: {
			index: 27,

			title: {
				en: "Visualisations",
				cym: "Delweddau",
			},

			downloads: [
                {
                    title: {
                        en: "Visualisations of what the Project will look like",
                        cym: "Delweddau o sut olwg fydd ar y prosiect"
                    },

                    url: {
                        en: "/morecambe/en/visualisations/",
                        cym: "/morecambe/cym/visualisations/"
                    },
                    imgSrc: {
                        en: "/assets/images/shared/downloads/morecambe/images/visualisations.jpg",
                        cym: "/assets/images/shared/downloads/morecambe/images/visualisations.jpg"
                    }
                }
			]
		},
    },

    nonstatConsultationMaterials: {
        index: 28,

        title: {
			en: "Consultation materials",
			cym: "Deunyddiau ymgynghori anstatudol",
		},

		downloads: [
			{
				title: {
				    en: "Morecambe and Morgan consultation brochure - Autumn 2022",
				    cym: "Llyfryn ymgynghori Morecambe a Morgan - Hydref 2022",
				},

				url: {
				    en: "/assets/images/shared/downloads/M&M-Condoc.pdf",
				    cym: "/assets/images/shared/downloads/M&M-Condoc.pdf",
				},
                imgSrc: {
                    en: "/assets/images/shared/downloads/morecambe/images/non-stat-brochure.jpg",
                    cym: "/assets/images/shared/downloads/morecambe/images/non-stat-brochure.jpg"
                }
			},

            {
				type: "video",
                videoId: "774795335",

				title: {
				    en: "Recording of online consultation event",
				    cym: "Cofnodi digwyddiad ymgynghori ar-lein",
				},
                imgSrc: {
                    en: "/assets/images/shared/downloads/morecambe/images/non-stat-video-webinar.jpg",
                    cym: "/assets/images/shared/downloads/morecambe/images/non-stat-video-webinar.jpg"
                }
			},

			{
				title: {
				    en: "Morecambe Offshore Wind Farm Scoping Report",
				    cym: "Adroddiad Cwmpasu Fferm Wynt Alltraeth Morecambe",
				},

				url: {
				    en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0007_Morecambe_Offshore_Windfarm_Scoping_Report_(Generation_Assets).pdf",
				    cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/FLO-MOR-REP-0007_Morecambe_Offshore_Windfarm_Scoping_Report_(Generation_Assets).pdf",
				},
                imgSrc: {
                    en: "/assets/images/shared/downloads/morecambe/images/scoping-report.jpg",
                    cym: "/assets/images/shared/downloads/morecambe/images/scoping-report.jpg"
                }
			},
        ]
    },

    projectUpdates: {
        index: 28,

        title: {
			en: "Project Updates",
			cym: "Deunyddiau ymgynghori anstatudol",
		},

		downloads: [
			{
				title: {
				    en: "Project update: Autumn 2023",
				    cym: "Diweddariad ar y prosiect: Hydref 2023",
				},

				url: {
				    en: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/MORECAMBE-GEN-Newsletter-spreads.pdf",
				    cym: "https://bp-mmt.s3.eu-west-2.amazonaws.com/morecambe/MORECAMBE-GEN-Newsletter-spreads.pdf",
				},
                imgSrc: {
                    en: "/assets/images/shared/morecambe-autumn-newsletter.jpg",
                    cym: "/assets/images/shared/morecambe-autumn-newsletter.jpg"
                }
			},
        ]
    },

    examination: {
        index: 29,

        title: {
			en: "Examination",
			cym: "Examination",
		},

		downloads: [
            {
				title: {
				    en: "Notice of issue-specific hearing - February 2025",
				    cym: "Hysbysiad o wrandawiad mater-benodol",
				},

				url: {
				    en: "/assets/images/downloads/Morecambe-Hearing-Notice-February.pdf",
				    cym: "/assets/images/downloads/Morecambe-Hearing-Notice-February.pdf",
				},
                imgSrc: {
                    en: "/assets/images/shared/downloads/morecambe/images/hearing-feb25.jpg",
                    cym: "/assets/images/shared/downloads/morecambe/images/hearing-feb25.jpg"
                }
			},
			{
				title: {
				    en: "Notice of issue-specific hearing",
				    cym: "Hysbysiad o wrandawiad mater-benodol",
				},

				url: {
				    en: "/assets/images/downloads/Morecambe-Hearing-Notice_final.pdf",
				    cym: "/assets/images/downloads/Morecambe-Hearing-Notice_final.pdf",
				},
                imgSrc: {
                    en: "/assets/images/shared/downloads/morecambe/images/hearing.jpg",
                    cym: "/assets/images/shared/downloads/morecambe/images/hearing.jpg"
                }
			},
        ]
    },

};